import { URI_FINANCIAL_ACCOUNT } from '@/config/config';

export default async ({ rootState }, { transactionId, licencePlate, startDate, endDate }) => {
  const token = rootState['DATA-ACCESS'].tokenAuth;
  const opts = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      'user-token': rootState['DATA-ACCESS'].userToken,
    },
  };

  const params = {};
  if (transactionId) params.transactionId = transactionId;
  if (licencePlate) params.licencePlate = licencePlate;
  if (startDate) params.startDate = startDate;
  if (endDate) params.endDate = endDate;

  const query = Object.keys(params)
    .map(k => `${encodeURIComponent(k)}=${encodeURIComponent(params[k])}`)
    .join('&');

  const path = `${URI_FINANCIAL_ACCOUNT}payment/vehicle-pix-transactions?${query}`;

  const response = await fetch(path, opts);
  const jsonResult = await response.json();

  if (jsonResult.status === 'error') {
    return Promise.reject(jsonResult.message);
  }

  return jsonResult;
};
